export default __webpack_public_path__ + "static/media/LE-popup.896449c5.png";